import { render } from "./BoletoForm.vue?vue&type=template&id=4e12ae4e&scoped=true"
import script from "./BoletoForm.vue?vue&type=script&lang=js"
export * from "./BoletoForm.vue?vue&type=script&lang=js"

import "./BoletoForm.vue?vue&type=style&index=0&id=4e12ae4e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e12ae4e"]])

export default __exports__